"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _reactJss = require("react-jss");
var _useColor = _interopRequireDefault(require("../utils/useColor"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var useStyles = (0, _reactJss.createUseStyles)({
  variables: function variables(_ref) {
    var color = _ref.color,
      duration = _ref.duration,
      glowSize = _ref.glowSize;
    return {
      "--glowColor": color,
      "--glowColorHalf": "".concat(color, "80"),
      "--glowDuration": "".concat(duration, "ms"),
      "--glowSize": "".concat(glowSize, "px"),
      "--glowSizeHalf": "".concat(glowSize / 2, "px")
    };
  },
  root: {
    boxShadow: "0 0 0 var(--glowColor)",
    animationDuration: "var(--glowDuration)",
    animationIterationCount: "infinite"
  },
  pulse: {
    animationName: "$iconPulse"
  },
  "@keyframes iconPulse": {
    "0%": {
      boxShadow: "0 0 0 var(--glowColor)"
    },
    "100%": {
      boxShadow: "0 0 0 var(--glowSize) transparent"
    }
  },
  wave: {
    animationName: "$iconWave",
    animationTimingFunction: "linear"
  },
  "@keyframes iconWave": {
    "0%": {
      boxShadow: "0 0 0 var(--glowSizeHalf) var(--glowColorHalf), 0 0 0 var(--glowColor)"
    },
    "100%": {
      boxShadow: "0 0 0 var(--glowSize) transparent, 0 0 0 var(--glowSizeHalf) var(--glowColorHalf)"
    }
  }
}, {
  name: "useGlow"
});
var useGlow = function useGlow() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "primary";
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2400;
  var glowSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "pulse";
  var hexColor = (0, _useColor.default)(color);
  var glowStyleProps = {
    duration: duration,
    color: hexColor,
    glowSize: glowSize
  };
  var classes = useStyles(glowStyleProps);
  return (0, _classnames.default)(classes.variables, classes.root, classes[type]);
};
var _default = exports.default = useGlow;